/* src/app/shared/page-templates/page-with-navigation/navigation-profile/navigation-profile.component.scss */
:host {
  --mat-button-text-label-text-color: var(--mat-sys-on-tertiary);
  --mat-button-text-state-layer-color: var(--mat-sys-on-tertiary);
}
/*# sourceMappingURL=navigation-profile.component-KELLA2GH.css.map */
